// Pokud zjistíte, že někde nesedí kód sportu s tím co vrací api, tak to prosím opravte
// U některých sportů jsem si jenom tipl jak by mohl kód sportu vypadat
// Pokud něco bude chybět, tak to prosím doplňte

export enum Sport {
    AlpineSkiing = "alpine-skiing",
    AmericanFootball = "american-football",
    Archery = "archery",
    Athletics = "athletics",
    AussieRules = "aussie-rules",
    Badminton = "badminton",
    Bandy = "bandy",
    Baseball = "baseball",
    Basketball = "basketball",
    BeachSoccer = "beach-soccer",
    BeachVolleyball = "beach-volleyball",
    Biathlon = "biathlon",
    Bowls = "bowls",
    Boxing = "boxing",
    Chess = "chess",
    Cricket = "cricket",
    Curling = "curling",
    Cycling = "cycling",
    Darts = "darts",
    Equestrian = "equestrian",
    Esports = "esports",
    Floorball = "floorball",
    Football = "football",
    Futsal = "futsal",
    GaelicFootball = "gaelic-football",
    Golf = "golf",
    Gymnastics = "gymnastics",
    Handball = "handball",
    Hockey = "hockey",
    HorseRacing = "horse-racing",
    IceHockey = "ice-hockey",
    Kabaddi = "kabaddi",
    Lacrosse = "lacrosse",
    MotorRacing = "motor-racing",
    Netball = "netball",
    NoveltiesSpecials = "novelties-specials",
    Pesapallo = "pesapallo",
    Politics = "politics",
    RugbyLeague = "rugby-league",
    RugbyUnion = "rugby-union",
    SkiJumping = "ski-jumping",
    Snooker = "snooker",
    Softball = "softball",
    Specials = "specials",
    Squash = "squash",
    Swimming = "swimming",
    TableTennis = "table-tennis",
    Tennis = "tennis",
    UfcMma = "ufc-mma",
    Volleyball = "volleyball",
    WaterPolo = "water-polo",
    WinterSports = "winter-sports",
    Yachting = "yachting",
    SazkaSpecials = "sazka-specials", // Most probably replaced with 'price-boost'
    PriceBoost = "price-boost",
}
